angular.module('logbook')
.directive('logSelector', ['$timeout', "$http", "$rootScope", "$location", "$window", 'logService',
function($timeout, $http, $rootScope, $location, $window, logService) {
  return {
    redirect: 'E',

    scope: {
       user: '=',
       selectedLog: '=',
       logs: '='
    },

	template: require('./log-selector.html'),

	  link: function(scope, elem, attrs) {
	   logService.getLogs().subscribe(logs => scope.logs = logs);
		
	   const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
	   
	   scope.hasHover = () => hoverQuery.matches;
		
       scope.selectLog = log => {
		   logService.selectLog(log);
       }
       
       scope.doNewLog = () => {
		   logService.selectLog(null, () => $location.url('/log-detail?tab=log'));
       };
       
       scope.goToLogSettings = function() {
          if (!scope.selectedLog) return;
          
          $location
              .path('/log-detail')
              .search('editLog', scope.selectedLog._links.self.href);
       }
       
       scope.getLastNoteTime = function(log)
       {
          if( log.lastNote )
             return log.lastNote.noteTime;
          return -1;
       }
       
       scope.notExpired = function()
       {
          return function(log)
          {
             return log.millisToFeatureExpiration['LogBook'] == null
                || log.millisToFeatureExpiration['LogBook'] > 0;
          };
	   }
		
	  if(scope.user.extendedData['expiration.LogBook'])
		  try {
			  scope.hideNewLog = new Date(scope.user.extendedData['expiration.LogBook']) <= new Date();
		  } catch(e) {}
	   
	   const _pendingInvitationsSubscription = logService.pendingLogInvitations$.subscribe(pendingInvitations => {
			scope.pendingLogInvitations = pendingInvitations;
	   });

	//    scope.$on('$destroy', function() {
	// 		_pendingInvitationsSubscription.unsubscribe();
	//    });
    }
  }
}]);
